import { useEffect } from 'react'
import { clone, remove } from 'lodash'
import * as Yup from 'yup'
import { AiOutlineClose, AiOutlinePlus } from 'react-icons/ai'

import { Button, SelectCreatable, TextInput } from 'Components/Form'
import { numberFormat, productUNIT } from 'Utils/helper'

export const productsSchema = Yup.object().shape({
    product_id: Yup.string().required('The product field is required.'),
    quantity: Yup.number().min(1, 'Quantity must be at least 1').required('The quantity field is required.'),
    lp: Yup.number().min(1, 'LP must be at least 1').required('The LP field is required.'),
    discount: Yup.number()
        .min(0, 'Discount must be at least 0')
        .max(100, 'Discount cannot exceed 100')
        .required('The discount field is required.'),
    price: Yup.number().min(1, 'Price must be at least 1').required('The price field is required.'),
    total: Yup.number().min(1, 'Total must be at least 1').required('The total field is required.'),
})

export const productsDefault = {
    product_id: '',
    quantity: '',
    lp: '',
    discount: '',
    price: '',
    total: '',
}

export default function Products({ index, datas, data, setFieldValue, touched, errors, products, selectedIds = [] }) {
    var name = `products[${index}].`

    useEffect(() => {
        const quantity = Number(data.quantity) || 0
        const lp = Number(data.lp) || 0
        const discount = Number(data.discount) || 0

        const price = numberFormat(lp - (discount * lp) / 100 || 0, 2, 'decimal', true)
        if (Number(data.price) !== price) {
            setFieldValue(`${name}price`, price)
        }
        const total = quantity * price
        if (Number(data.total) !== total) {
            setFieldValue(`${name}total`, numberFormat(total, 2, 'decimal', true))
        }
        // eslint-disable-next-line
    }, [data.quantity, data.lp, data.discount])

    var product = products.find(e => e.id === data.product_id)

    return (
        <div className="grid grid-cols-2 gap-3 md:grid-cols-10">
            <SelectCreatable
                id={`${name}product_id`}
                name={`${name}product_id`}
                label="Product"
                placeholder="Product"
                value={products
                    .map(e => ({
                        value: e.id,
                        label: e.sku + ' - ' + e.name + ' - ' + e.brand?.name,
                    }))
                    .find(e => e.value === data.product_id)}
                options={products
                    .filter(e => !selectedIds.includes(e.id) || e.id === data.product_id)
                    .map(e => ({
                        value: e.id,
                        label: e.sku + ' - ' + e.name + ' - ' + e.brand?.name,
                    }))}
                onChange={e => {
                    setFieldValue(`${name}product_id`, e.value)
                    var product = products.find(p => p.id === e.value)
                    setFieldValue(`${name}price`, product?.price ?? 0)
                }}
                className="col-span-2 md:col-span-4"
                error={touched?.product_id && errors?.product_id}
            />
            <TextInput
                type="number"
                id={`${name}quantity`}
                name={`${name}quantity`}
                label={`Quantity (${(product?.unit ?? null) !== null ? productUNIT(product.unit, true) : ''})`}
                placeholder="Quantity"
                value={data.quantity}
                onChange={e => setFieldValue(`${name}quantity`, e.target.value)}
                error={touched?.quantity && errors?.quantity}
            />
            <TextInput
                type="number"
                id={`${name}lp`}
                name={`${name}lp`}
                label="LP"
                placeholder="LP"
                value={data.lp}
                onChange={e => setFieldValue(`${name}lp`, e.target.value)}
                error={touched?.lp && errors?.lp}
            />
            <TextInput
                type="number"
                id={`${name}discount`}
                name={`${name}discount`}
                label="Discount %"
                placeholder="Discount %"
                value={data.discount}
                onChange={e => setFieldValue(`${name}discount`, e.target.value)}
                error={touched?.discount && errors?.discount}
            />
            <TextInput
                disabled
                type="number"
                id={`${name}price`}
                name={`${name}price`}
                label="Price"
                placeholder="Price"
                value={data.price}
                onChange={e => setFieldValue(`${name}price`, e.target.value)}
                error={touched?.price && errors?.price}
            />
            <TextInput
                disabled
                type="number"
                id={`${name}total`}
                name={`${name}total`}
                label="Total"
                placeholder="Total"
                value={data.total}
                onChange={e => setFieldValue(`${name}total`, e.target.value)}
                error={touched?.total && errors?.total}
            />
            <div>
                <div className="flex items-center gap-3 pt-7">
                    {index + 1 === datas.length ? (
                        <Button
                            type="button"
                            className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                            onClick={() => {
                                var saveTask = clone(datas)
                                saveTask.push(productsDefault)
                                setFieldValue('products', saveTask)
                            }}
                        >
                            <AiOutlinePlus size={20} />
                        </Button>
                    ) : null}
                    {1 !== datas.length ? (
                        <Button
                            type="button"
                            className="text-white border-danger bg-danger"
                            onClick={() => {
                                var saveTask = clone(datas)
                                remove(saveTask, (n, key) => key === index)
                                setFieldValue('products', saveTask)
                            }}
                        >
                            <AiOutlineClose size={20} />
                        </Button>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
